import React from "react";
import CreateReactClass from "create-react-class";
import PropTypes from "prop-types";

import ReactSelect from "react-select";

import _ from "lodash";

let Select = CreateReactClass({
  propTypes: {
    className: PropTypes.string,
    placeholder: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object), // [{value, label}, ...]
    selected: PropTypes.any, // selected value
    onChange: PropTypes.func, // => (value)
    valueKey: PropTypes.string, //the option property to use for the value
    labelKey: PropTypes.string, //the option property to use for the label
    sort: PropTypes.func, //comparator function for sorting
  },
  getDefaultProps: function () {
    return {
      placeholder: "Please select...",
      options: [{}],
      valueKey: "value",
      labelKey: "label",
      sort: function (optionA, optionB) {
        var labelA = optionA[this.props.labelKey].toUpperCase(); // ignore case
        var labelB = optionB[this.props.labelKey].toUpperCase(); // ignore case
        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0;
      }
    };
  },
  handleChange: function (option) {
    if (option == null) { //undef or null
      this.props.onChange && this.props.onChange(null);
    } else {
      this.props.onChange && this.props.onChange(option.value);
    }
  },
  render: function () {
    // sort options
    let options = this.props.options.sort(this.props.sort.bind(this));
    // map value/label keys
    options = options.map(option => ({
      value: option[this.props.valueKey],
      label: option[this.props.labelKey],
    }));
    // find the selected object by value
    let selected = _.find(options, { value: this.props.selected });
    return <ReactSelect
      placeholder={this.props.placeholder}
      className={this.props.className}
      classNamePrefix="react-select"
      value={selected}
      options={options}
      onChange={this.handleChange}
    />;
  }

});

export default Select;
